import React from "react"
import BackArrow from "./back-arrow"
import ErrorMessage from "./error-message"
import Keypad from "./keypad"

class NewUser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imgSrc: null
    }

    this.handleFileChange = (e) => {
      e.preventDefault()
      const reader = new FileReader()
      const file = e.target.files[0]
      reader.onloadend = () => {
        this.setState({imgSrc: reader.result})
        this.props.onChangeNewUserImage(file)
      }
      reader.readAsDataURL(file)
    }
  }

  render() {
    const props = this.props
    return (
      <div className="clock-in-panel__new-user" style={props.newUserStyle}>
        <BackArrow {...props}/>
        <div className="clock-in-window">
          <h1>New User</h1>
          <div className="clock-in-new-user__name">
            <input placeholder="First Name" type="text" value={props.newUser.firstName}
              onChange={props.onChangeNewUserFirstName}/>
            <input placeholder="Last Name" type="text" value={props.newUser.lastName}
              onChange={props.onChangeNewUserLastName}/>
            <label>
              Photo
              <div className="image-wrapper">
                <img src={this.state.imgSrc || "/images/clock-in/user-image-placeholder.png"}/>
              </div>
              <input type="file" onChange={this.handleFileChange}/>
            </label>
          </div>
          <div className="clock-in-new-user__keypad">
            <Keypad value={props.currentPin}
              onClickDelete={props.onDeletePinNumber}
              onClickNumber={props.onClickPinNumber}
              onClickSubmit={props.context === "new_user" ? props.onSetNewUserPin : props.onConfirmNewUser}
              showIndicator
              submitButtonClass={props.keypadButtonClass}
              submitButtonText={props.keypadButton}/>
            {props.errorText && <ErrorMessage text={props.errorText}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default NewUser
